export default class TableOptions {
  public id?: number;
  public name?: string;
  public tableId?: number;
}
